import { render, staticRenderFns } from "./FormFile.vue?vue&type=template&id=378a08c8&"
import script from "./FormFile.vue?vue&type=script&lang=js&"
export * from "./FormFile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/digital-seaside/sst-admin-panel/webapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('378a08c8')) {
      api.createRecord('378a08c8', component.options)
    } else {
      api.reload('378a08c8', component.options)
    }
    module.hot.accept("./FormFile.vue?vue&type=template&id=378a08c8&", function () {
      api.rerender('378a08c8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/file/form/FormFile.vue"
export default component.exports